import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { PolicyStatusEnum } from '../../../tenant/policies/enums/policy-status.enum';
import { PolicyTypeEnum } from '../../../tenant/policies/enums/policy-type.enum';

/**
 * Proto policy DTO for records
 */
@CaslSubject(AppSubjectEnum.POLICY)
export class ProtoPolicyRecordDto extends BaseProtoDto {
  type!: PolicyTypeEnum;
  name?: string;
  config!: Record<string, unknown>;
  notes?: string;
  status!: PolicyStatusEnum;
}
